import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, unref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { useRouter, useRoute } from 'vue-router'
import Writer from './Writer.vue'

/* Api */
import { CpEditorApi, CpDetailApi } from '@/apis/counterpart/counterpart.api'

/* Types */
import { CounterparDetail } from '@/apis/counterpart/counterpart.type';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { query } = useRoute()
const writerRef = ref<ComponentRef<typeof Writer>>()

onMounted(() => {

    const dataRowId: string = query.rowId as string

    const writer = unref(writerRef)

    if (writer) {

        writer?.methods.setData(dataRowId)

    }

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Writer, {
    ref_key: "writerRef",
    ref: writerRef,
    titles: `相对方详细信息`,
    isPreview: true
  }, null, 512))
}
}

})